import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type {
	CreateOrUpdateSellerProfileData,
	SellerProfile,
} from "~/modules/billing/sellerProfile/sellerProfileTypes.ts";

const sellerProfileBasePath = "seller-profile";

export function showSellerProfile(): AxiosApiResponsePromise<SellerProfile> {
	return axiosApi.get(sellerProfileBasePath);
}

export function createOrUpdateSellerProfile(sellerProfileData: CreateOrUpdateSellerProfileData): AxiosApiResponsePromise<SellerProfile> {
	return axiosApi.put(sellerProfileBasePath, sellerProfileData);
}